import { useAuth } from "@/contexts/AuthContext";

export interface Profile {
  id: string;
  user_id: string;
  nome_exibicao: string | null;
  telefone: string | null;
  foto_perfil_base64: string | null;
  created_at: string;
  updated_at: string;
}

export const useProfile = () => {
  const { user } = useAuth();

  return {
    profile: user
      ? {
          id: user.id,
          user_id: user.id,
          nome_exibicao: user.nome || user.email,
          telefone: null,
          foto_perfil_base64: null,
          created_at: "",
          updated_at: "",
        }
      : null,
    isLoading: false,
    updateProfile: () => undefined,
    isUpdating: false,
  };
};
